import React, { useContext } from 'react'
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
//React export function used to logout the user.
export default function Logout() {
    const { setIsLoggedIn, setLoginRefreshRequired } = useContext(LoginStatusContext)
    //Reset the logged in seesion to be false 

    const url = `${process.env.REACT_APP_API_ENDPOINT}/api/login/endsession`;
    axios.post(url).then(() => 
    {
        setIsLoggedIn(false);
        setLoginRefreshRequired(true);
        sessionStorage.clear();
        window.location.replace(`${process.env.PUBLIC_URL}/login`);

    }).catch((err) => {
        console.error(err.response.data);
    });
}